import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Test from "@/pages/Test";
import Diagnostic from "@/pages/DiagnosticBooking";
import ArticlesIndex from "@/pages/ArticlesIndex";
import Article from "@/pages/Article";
import { Toaster } from "@/components/ui/sonner";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/test" element={<Test />} />
                    <Route path="/diagnostic" element={<Diagnostic />} />
                    <Route path="/articles" element={<ArticlesIndex />} />
                    <Route path="/articles/:slug" element={<Article />} />
                </Routes>
            </BrowserRouter>
            <Toaster
                position="top-center"
                toastOptions={{
                    classNames: {
                        toast: "bg-white border border-ink-200 text-ink-900 shadow-lg",
                    },
                }}
            />
        </div>
    );
}

export default App;
